module.exports = require("./fr-DZ.js");